import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useMutation } from "@apollo/client";

import styled from "styled-components";
import { H5, P } from "../Texts";
import { Badge, PrimaryButton, LinkButton } from "../Buttons";
import AcceptRejectlModal from "../../organisms/AcceptRejectModal";
import OrgDetails from "../../organisms/OrgDetails";

import { ACCEPT_OPT_IN, REJECT_OPT_IN } from "../../../shared/queries";

import { toastError, toastSuccess } from "../../../shared/helpers";

const InitiativeOptCardStyle = styled.div`
  border-radius: 3px;
  // width: ${(props) => props.width || "fit-content"};
  width: ${(props) => props.width || "333.67px"};
  // height: ${(props) => props.height || "360px"};
`;

export const InitiativeOptCard = ({ orgId, request, width, height, type }) => {
  const { id, initiativeName, initiativeAddress, status, organization } = request;

  const [showCaseModal, setShowCaseModal] = useState(false);
  const [showRejectModal, setShowRejectModal] = useState(false);

  const [showOrg, setShowOrg] = useState(false);
  const [badgeColor, setBadgeColor] = useState({});

  const toggleModal = () => setShowCaseModal(!showCaseModal);
  const toggleRejectModal = () => setShowRejectModal(!showRejectModal);
  const toggleOrgeModal = () => setShowOrg(!showOrg);

  // approve opt initiative
  const [approveOptIn, { loading }] = useMutation(ACCEPT_OPT_IN);

  const handleApproveOpt = () => {
    approveOptIn({
      variables: {
        optinId: id,
        organizationId: orgId,
      },
    })
      .then(() => {
        toastSuccess("Opt-in request approved");
        toggleModal();
        // reload page
      })
      .catch((error) => {
        toastError(error?.message);
      });
  };

  // reject opt initiative
  const [rejectOptIn, { loading: isLoading }] = useMutation(REJECT_OPT_IN);

  const handleRejecteOpt = () => {
    rejectOptIn({
      variables: {
        optinId: id,
        organizationId: orgId,
      },
    })
      .then(() => {
        toastSuccess("Opt-in request rejected");
        toggleRejectModal();
        // reload page
      })
      .catch((error) => {
        toastError(error?.message);
      });
  };

  React.useEffect(() => {
    switch (true) {
      case status === "rejected":
        setBadgeColor({
          bgColor: "#FDD2DC",
          textColor: "#7C033C",
        });
        break;

      case status === "approved":
        setBadgeColor({
          bgColor: "#D8FDEC",
          textColor: "#167C3C",
        });
        break;

      default:
        setBadgeColor({
          bgColor: "#FFF8F0",
          textColor: "#E08304",
        });
        break;
    }

    return () => {
      setBadgeColor({});
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <InitiativeOptCardStyle
      width={width}
      height={height}
      className="bg-white py-5 px-8  hover:shadow-sm duration-300"
    >
      <div>
        <div className="">
          <H5 fontFamily="semi" color="#000000" fontSize="18px">
            {initiativeName}
          </H5>

          <P color="#00000099" fontSize="16px" smallSize="14px" fontFamily="normal">
            {initiativeAddress}
          </P>

          {type === "received" && (
            <div>
              <div className="mt-5">
                <H5 color="#000000" fontSize="16px">
                  {organization?.name}
                </H5>

                <LinkButton
                  onClick={toggleOrgeModal}
                  color="#442ED0"
                  className="text-left font-normal"
                  fontSize="14px"
                  fontFamily="normal"
                  p="0px"
                >
                  view Organization
                </LinkButton>
              </div>

              {status === "pending" ? (
                <div className="mt-6 flex justify-center gap-x-4">
                  <PrimaryButton
                    className="flex-1"
                    style={{ backgroundColor: "#442ED0", borderRadius: "3px" }}
                    onClick={toggleModal}
                  >
                    Approve
                  </PrimaryButton>

                  <PrimaryButton.Light
                    className="flex-1"
                    style={{ backgroundColor: "#DCD6FE", borderRadius: "3px" }}
                    onClick={toggleRejectModal}
                  >
                    Reject
                  </PrimaryButton.Light>
                </div>
              ) : (
                <div className="mt-6">
                  <Badge
                    className="capitalize"
                    fontSize="14px"
                    fontFamily="poppins"
                    bg={badgeColor.bgColor}
                    color={badgeColor.textColor}
                    fontWeight="normal"
                    p="4px 12px"
                  >
                    {status}
                  </Badge>
                </div>
              )}
            </div>
          )}

          {type === "sent" && (
            <div className=" mt-12">
              <P color="#4F4F4F" fontFamily="normal" fontSize="12px">
                Your request to join this initiative is {status}
              </P>

              <Badge
                className="capitalize mt-4"
                fontSize="14px"
                fontFamily="medium"
                bg={badgeColor.bgColor}
                color={badgeColor.textColor}
                p="4px 12px"
              >
                Request {status}
              </Badge>
            </div>
          )}
        </div>
      </div>

      {showOrg && (
        <OrgDetails orgId={organization?.id} closeModal={toggleOrgeModal} />
      )}

      {showCaseModal && (
        <AcceptRejectlModal
          header="Approve Opt-In Request"
          text={`Allow ${organization?.name} join this initiative`}
          cta="Approve"
          action={handleApproveOpt}
          closeModal={toggleModal}
          loading={loading}
        />
      )}

      {showRejectModal && (
        <AcceptRejectlModal
          header="Reject Opt-In Request"
          text={`Reject  ${organization?.name} join this initiative`}
          cta="Reject"
          action={handleRejecteOpt}
          closeModal={toggleRejectModal}
          loading={isLoading}
        />
      )}
    </InitiativeOptCardStyle>
  );
};
